import "../css/hierarchy.css";
import { ReactComponent as CalenderIcon } from "../assets/icons/calender.svg";
import { ReactComponent as ClockIcon } from "../assets/icons/clock.svg";
import DefaultUser from "../assets/imgs/default_user.png";

export default function Hierarchy({ data }) {
  return (
    <div className="hierarchy-container">
      <div className="hierarchy-header">
        <h3>{data.title}</h3>
        <div className="hierarchy-meta">
          <span>
            <CalenderIcon className="vaMiddle" width={15} /> <span className="vaMiddle">{data.dateRange}</span>
          </span>
          <span>
            <ClockIcon className="vaMiddle" width={15} /> <span className="vaMiddle">{data.time}</span>
          </span>
          <span>
            {" "}
            <img
              className="card-user-img vaMiddle"
              src={DefaultUser}
              alt="user_image"
            />{" "}
            {data.user}
          </span>
        </div>
      </div>

      <div className="vertical-connector" />

      <div className="hierarchy-body">
        <div className="horizontal-line" />
        <div className="hierarchy-children">
          {data.children.map((child, index) => (
            <div key={index} className="hierarchy-node">
              <div className="child-connector" />{" "}
              {/* vertical connector above card */}
              <div className="node-card">
                <h4>{child.title}</h4>
                <span className="node-date">{child.date}</span>
                <div className="node-items">
                  {child.items.map((item, idx) => (
                    <div key={idx} className="node-item">
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
